import styled, { css } from "styled-components";

import {
  ACCENT_PRIMARY_LIGHT,
  ACCENT_PRIMARY_LIGHTEST,
  TEXT_PRIMARY
} from "../../colors";
import { LARGE_SCREEN } from "../../constants/screenSizes";
import { smallCrossIcon } from "../assets";

const withIconStyles = ({ hideIcon }) =>
  !hideIcon &&
  css`
    background-image: url(${smallCrossIcon});
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    padding-right: 32px;
  `;

export const FilterChip = styled.button`
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
  border: 0;
  border-radius: 28px;
  color: ${TEXT_PRIMARY};
  cursor: pointer;
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  font-size: 14px;
  line-height: 24px;
  padding: 6px 16px;
  white-space: nowrap;

  &:hover,
  &:focus {
    background-color: ${ACCENT_PRIMARY_LIGHT};
  }

  &:focus {
    outline: 1px solid ${TEXT_PRIMARY};
    outline-offset: 2px;
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
  }

  ${withIconStyles};
`;
